<template>
  <div class="debtrelief-agent-my-team">
    <nav-bar 
      titleText="我的团队" 
      rightText="团队政策解读" 
      @goBack="goBack" 
      :isFixed="true" 
      rightSize="13px" 
      @rightTextEvent="getPolicyInfo">
    </nav-bar>
    <div class="empty1"></div>
    <div class="my-team-head">
      <div class="desc">
        <div class="left">
          <img :src="!agentTeamInfo.member_avator ? agentimg : agentTeamInfo.member_avator" alt="">
        </div>
        <div class="right">
          <div class="name">{{agentTeamInfo.member_realname}}</div>
          <div class="position-box">
            <span class="level">级别</span>
            <span class="position">{{agentLevel}}</span>
          </div>
          <div class="agent-code">
            <span class="text">经纪人代码</span>
            <span class="code">{{agentTeamInfo.agent_code}}</span>
          </div>
        </div>
      </div>
      <div class="result">
        <div class="result-left">
          <div class="amount">{{parseFloat(agentTeamInfo.achievement).toFixed(2)}}</div>
          <div class="total-amount">累计团队业绩</div>
          <div class="detail" @click="goPerforDetail">
            <span>明细</span>
            <span class="img">
              <img src="../../../assets/debtor/icon1.png" alt="">
            </span>
          </div>
        </div>
        <div class="line"></div>
        <div class="result-right">
          <div class="amount">{{parseFloat(agentTeamInfo.allowance).toFixed(2)}}</div>
          <div class="total-amount">累计团队管理津贴</div>
          <div class="detail" @click="goAllowanceDetail">
            <span>明细</span>
            <span class="img">
              <img src="../../../assets/debtor/icon1.png" alt="">
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="empty2"></div>
    <div class="member-list-box">
      <div class="title-box">
        <div class="left">
          <img src="../../../assets/debtor/memberIcon.png" alt="">
          <div class="title-text">团队成员名单</div>
        </div>
        <div class="right">
          <span class="title-box-right-title">团队总计{{agentTeamInfo.agent_team}}人</span>
          <span class="refresh-btn" @click="refreshList">
          <img :src="reloadgrayicon" alt="">
        </span>
        </div>
      </div>
      <div class="my-team-search">
        <van-search
          v-model="value"
          left-icon
          show-action
          placeholder="经纪人代码/会员手机号"
          @search="onSearch"
          @clear="clearEvent"
        >
          <template #action>
            <div @click="onSearch" style="color: #F9591B">搜索</div>
          </template>
        </van-search>
      </div>
      <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh"> -->
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <!-- <van-cell v-for="item in memberList" :key="item" :title="item"/>  -->
          <div class="member-list" v-for="(item, i) in memberList" :key="i">
            <div class="mermber-item">
              <div class="left">
                <img :src="!item.member_avator ? agentimg : item.member_avator" alt="">
                <div class="item-info">
                  <p class="name">{{item.member_realname}}</p>
                  <p class="code">
                    <span>经纪人代码</span>
                    <span>{{item.agent_code}}</span>
                  </p>
                  <p class="iphone">
                    <span>会员手机号</span>
                    <span>{{item.member_mobile}}</span>
                  </p>
                  <p class="add-time">
                    <span>加入时间</span>
                    <span>{{item.join_time}}</span>
                  </p>
                  <p class="add-time">
                    <span>到期时间</span>
                    <span>{{item.agent_end_time}}</span>
                  </p>
                </div>
              </div>
              <div class="right">
                <span>状态</span>
                <span>{{ freezeMap[String(item.freeze)] }}</span>
              </div>
            </div>
          </div>
        </van-list>
      <!-- </van-pull-refresh> -->

    </div>
  </div>
</template>

<script>
import navBar from "../components/navBar";
export default {
  data() {
    return {
      memberList: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 0,
      pageSize: 10,
      value: "",
      agentTeamInfo: {},
      agentLevel: '',
      status: '',
      freezeMap: {
        '0': '正常',
        '1': '冻结',
        '2': '合同到期',
      },
      agentimg:require('@/assets/debtor/actver.png'),
      reloadgrayicon: require('@/assets/debt/reload-gray-icon.png'),
    }
  },
  components:{
    navBar
  },
  created() {
    this.getAgentTeam()
  },
  mounted() {

  },
  methods: {
    refreshList() {
        if (!this.refreshing) {
          this.refreshing = true
          this.page = 0;
          this.onLoad();
        }
      },
    onSearch(value){
      this.$api.post('debt/member/agent/team-query',{
        condition: this.value
      })
      .then((data) => {
        this.memberList.length = 0
        this.memberList.push(...data)
      })
    },
    clearEvent() {
      this.onSearch('')
    },
    getAgentTeam() {
      this.$api.post('debt/member/agent/team')
      .then((data) => {
        this.agentTeamInfo = data
        if(data.agent_identity == 0){
          this.agentLevel = '普通'
        }else if(data.agent_identity == 1) {
          this.agentLevel = '主管'
        }else if(data.agent_identity == 2) {
          this.agentLevel = '经理'
        }
        
      })
      .catch((err) => {
        console.log(err)
        this.$toast(err.message)
      })
    },
    onLoad() {
      this.getMemberList();
    },
    onRefresh() {
      this.page = 0;
      this.onLoad();
    },
    getMemberList() {
      this.page ++
      const param = {
        page: this.page,
        size: this.pageSize,
      }
      this.$api.post("debt/member/agent/agent-list", param)
      .then(res => { 
        let _list = res.list

        if (this.refreshing) {
          this.memberList = [];
          this.finished = false;
        }

        this.memberList.push(..._list)
        if (this.memberList.length === 0) {
          this.finished = true;
          this.loading = false;
          this.refreshing = false;
          return;
        }
        this.loading = false;
        if (res.current_page === res.last_page) {
          this.finished = true;
        }
        if (this.refreshing) {
          this.$toast("刷新成功");
          this.refreshing = false;
        }
        if (!this.finished && !this.loading && this.memberList.length <= 3) {
          this.onLoad();
        }
      })
      .catch((err) => {
        this.loading = false;
        this.finished = true;
        if(err.message) {
          this.$toast(err.message)
        }
      });
    },
    goBack() {
      this.$router.go(-1)
    },
    goPerforDetail() {
      this.$router.push('/agent/perforDetail')
    },
    goAllowanceDetail() {
      this.$router.push('/agent/allowanceDetail')
    },
    getPolicyInfo() {
      this.$router.push('/agent/policyInfo')
    
    },

  }
}
</script>

<style lang="less">
html{
  overflow-x: inherit;
}
.debtrelief-agent-my-team {
  padding-top: 88px;
  .empty1 {
    height: 12px;
    width: 100%;
    background: #f5f6f7;
  }
  .my-team-head {
    padding: 0 12px;
    .desc {
      display: flex;
      align-items: center;
      padding-top: 22px;
      .left {
        width: 57px;
        height: 57px;
        margin-right: 9px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      .right {
        .name {
          height: 26px;
          font-size: 16px;
          font-weight: 500;
          color: #333333;
          line-height: 26px;
        }
        .position-box {
          height: 21px;
          font-size: 13px;
          color: #999999;
          line-height: 21px;
          display: flex;
          .level {
            padding-right: 5px;
          }
        }
        .agent-code {
          height: 21px;
          font-size: 13px;
          color: #999999;
          line-height: 21px;
          .text {
            padding-right: 5px;
          }
        }
      }
    }
    .result {
      padding: 24px 0 17px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .result-left, .result-right{
        text-align: center;
        .amount {
          height: 21px;
          font-size: 15px;
          font-weight: 600;
          color: #333333;
          line-height: 21px;

        }
        .total-amount {
          height: 23px;
          font-size: 14px;
          color: #333333;
          line-height: 23px;

        }
        .detail {
          height: 21px;
          font-size: 13px;
          color: #2A62FC;
          line-height: 21px;
          .img {
            display: inline-block;
            width: 6px;
            height: 10px;
            margin-left: 4px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .line {
        width: 1px;
        height: 48px;
        background: #DDDDDD;
      }
    }
  }

  .empty2 {
    height: 12px;
    width: 100%;
    background: #f5f6f7;
  }
  .member-list-box {
    padding: 12px 12px 0;
    .title-box {
      margin-bottom: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        display: flex;
        align-items: center; 
        position: relative;
        img {
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-60%);
          width: 20px;
          height: 15px;
        }

        .title-text {
          height: 26px;
          font-size: 16px;
          font-weight: 600;
          color: #333333;
          line-height: 26px;
          padding-left: 26px;
        }
      }
      .right {
        height: 21px;
        font-size: 13px;
        color: #999999;
        line-height: 21px;
        position: relative;
        .title-box-right-title{
          margin-right: 26px;
        }
        .refresh-btn {
          position: absolute;
          right: 3px;
          bottom: 2px;
          width: 20px;
          height: 20px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .my-team-search {
      .van-search {
        padding-left: 0px;
      }
      .van-search__content {
        padding-left: 12px;
        height: 35px;
        background: #F8F8F8;
        border-radius: 4px;
        border: 1px solid #EEEEEE;
      }
      .van-search__action {
        padding: 0 0 0 12px;
      }
    }

    .member-list {
      .mermber-item {
        display: flex;
        justify-content: space-between;
        padding: 12px 0 12px;
        border-bottom: 1px solid #EEEEEE;
        // align-items: center;
        .left {
          display: flex;
          img {
            width: 41px;
            height: 41px;
            margin-right: 12px;
            border-radius: 50%;
          }
          .item-info {
            .name {
              height: 26px;
              font-size: 16px;
              font-weight: 600;
              color: #333333;
              line-height: 26px;
            }
            .code, .iphone, .add-time {
              height: 21px;
              font-size: 13px;
              color: #999999;
              line-height: 21px;
              :nth-of-type(1) {
                padding-right: 5px;
              }
            }
          }
         
        }
        .right {
          height: 23px;
          font-size: 14px;
          color: #CCCCCC;
          line-height: 23px;
          :nth-of-type(1) {
            padding-right: 5px;
          } 
        }
      }
    }

  }
}
</style>
